import React from "react";
import { Button } from "semantic-ui-react";

import styles from "./FormButton.module.css";

export const FormButton = props => {
  const btnClass = props.active
    ? `${styles.formButton} ${styles.active}`
    : styles.formButton;
  return (
    <Button
      type="button"
      fluid
      className={btnClass}
      onClick={() => props.handleItemClick()}
    >
      {props.children}
    </Button>
  );
};

export default FormButton;



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/FormButton.jsx